import script from "./BalanceList.vue?vue&type=script&setup=true&lang=js"
export * from "./BalanceList.vue?vue&type=script&setup=true&lang=js"

import "./BalanceList.vue?vue&type=style&index=0&id=13422a78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13422a78"]])

export default __exports__